import { apiSlice } from '@/api'

export const loggingApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLogging: builder.query({
      query: (args) => {
        const { channelId, page, size } = args
        return {
          url: `api/v2/channels/gate_openings/${channelId}`,
          method: 'GET',
          params: { page, size }
        }
      }
    })
  })
})

export const { useGetLoggingQuery } = loggingApi
